import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface AlertStatus {
  alertasUsadas: number;
  alertasLimite: number;
  isPremium: boolean;
  paywallActivo: boolean;
  whatsappOptIn: boolean;
  whatsappPhoneSet?: boolean;
  whatsappPhone?: string;
  correoSet?: boolean;
  correoPreview?: string;
  alertFrequency?: string;
  freeAlertEmail?: boolean;
  freeAlertWhatsapp?: boolean;
  freebieUsado?: boolean;
  freebiePromptDismissed?: boolean;
}

@Injectable({ providedIn: 'root' })
export class AlertService {
  private base = `${environment.baseApi}/privado/alertas`;

  constructor(private http: HttpClient) {}

  getEstado(candidatoId: number): Observable<any> {
    return this.http.get(`${this.base}/estado/${candidatoId}`);
  }

  updateWhatsapp(candidatoId: number, optIn: boolean, phone?: string): Observable<any> {
    return this.http.patch(`${this.base}/whatsapp/${candidatoId}`, { optIn, phone });
  }

  updateFrecuencia(candidatoId: number, frequency: string): Observable<any> {
    return this.http.patch(`${this.base}/frecuencia/${candidatoId}`, { frequency });
  }

  sendOtp(phone: string, candidatoId: number): Observable<any> {
    return this.http.post(`${this.base}/whatsapp/otp/send`, { phone, candidatoId });
  }

  verifyOtp(phone: string, code: string, candidatoId: number): Observable<any> {
    return this.http.post(`${this.base}/whatsapp/otp/verify`, { phone, code, candidatoId });
  }

  dismissFreebiePrompt(candidatoId: number): Observable<any> {
    return this.http.post(`${this.base}/freebie/dismiss/${candidatoId}`, {});
  }
}
